/* import __COLOCATED_TEMPLATE__ from './status-cell.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseImpersonationConsentsCell from 'embercom/components/table-cells/impersonation-consents/base-cell';
export default BaseImpersonationConsentsCell.extend({
  init() {
    this._super(...arguments);
  },
});
